import { DynamicStyleSheet } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    paddingVertical: 12,
  },
  textError: {
    color: theme.colors.formFieldErrorText,
  },
  textSuccess: {
    color: theme.colors.formFieldSuccessText,
  },
  top: {
    paddingBottom: 8,
    color: theme.colors.formFieldTopText,
  },
  bottom: {
    paddingTop: 8,
    color: theme.colors.formFieldBottomText,
  },
}));
